import React from 'react';
import { Divider } from 'antd';

export const Separator: React.FC = () => {
	return <Divider type="vertical" style={{ margin: 0, height: 'auto' }} />;
};
